const BarraLluvia = (props) => {
  const { x, y, width, height, fill } = props;

  // Si el valor es 0, dibujamos una barra mínima
  const adjustedHeight = height === 0 ? 2 : height;
  const adjustedY = height === 0 ? y - 2 : y;

  return (
    <rect
      x={x}
      y={adjustedY}
      width={width}
      height={adjustedHeight}
      fill={fill}
    />
  );
};


export default BarraLluvia;
